export default "__VITE_ASSET__Ce8y9ddw__";